<script>
  import tiposConta from '~js/tipos-conta';
  
  export default {
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      dadosBancarios: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        tiposConta: tiposConta,
        tiposContaAux: tiposConta,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      nomeTipoConta(tipo) {
        tipo = tipo !== -1 ? tipo : -1;
        if (tipo == -1) {
          return "---";
        } else {
          return this.tiposContaAux.find(tipoConta => {
            return tipoConta.id === tipo;
          }).nome;
        }
      },
      selecionar(dadoBancario) {
        this.solicitacao.banco = dadoBancario.numeroBanco;
        this.solicitacao.agencia = dadoBancario.numeroAgencia;
        this.solicitacao.contaCorrente = dadoBancario.numeroConta;
        this.solicitacao.tipoConta = dadoBancario.tipoConta;
      },
      arrayRemove(arr, value) {
         return arr.filter(function(ele){
             return ele.id != value;
         });
      },
      aplicaconfiguracaoweb() {
        if (this.configuracao) {
          // Visualização Tipos Contas
          this.tiposConta = this.arrayRemove(this.tiposConta, -1);

          if (!this.configuracao.solPgtoPJTipoContaCC)
            this.tiposConta = this.arrayRemove(this.tiposConta, 0);

          if (!this.configuracao.solPgtoPJTipoContaCP)
            this.tiposConta = this.arrayRemove(this.tiposConta, 1);

          if (!this.configuracao.solPgtoPJTipoContaCS)
            this.tiposConta = this.arrayRemove(this.tiposConta, 2);
        }
      },
    },
    mounted() {
      this.aplicaconfiguracaoweb();
    },
  }
</script>

<template>
  <div>
    
    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Banco</th>
            <th>Agência</th>
            <th>Número da conta</th>
            <th>Tipo de conta</th>
            <th>Conta padrão</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dadoBancario in dadosBancarios" @click="selecionar(dadoBancario)">
            <td>{{ dadoBancario.numeroBanco }}</td>
            <td>{{ dadoBancario.numeroAgencia }}</td>
            <td>{{ dadoBancario.numeroConta }}</td>
            <td>{{ nomeTipoConta(dadoBancario.tipoConta) }}</td>
            <td>{{ dadoBancario.contaPadrao ? 'Sim' : 'Não' }}</td>
          </tr>
          <tr v-if="dadosBancarios.length === 0">
            <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5"><small>Clique sobre o dado bancário para seleciona-lo.</small></td>
          </tr>
        </tfoot>
      </table>
    </div>
    
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('banco')}">
          <label class="control-label" for="banco">Banco</label>

          <input
              type="text"
              class="form-control"
              id="banco"
              maxlength="20"
              v-model="solicitacao.banco"
              data-vv-name="banco"
              data-vv-as="banco"
              v-validate="solicitacao.formaPagamento == 0 ? 'required' : ''">

          <p class="text-danger" v-show="errors.has('banco')">{{ errors.first('banco') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('agencia')}">
          <label class="control-label" for="agencia">Agência</label>

          <input
              type="text"
              class="form-control"
              id="agencia"
              maxlength="6"
              v-model="solicitacao.agencia"
              data-vv-name="agencia"
              data-vv-as="agência"
              v-validate="solicitacao.formaPagamento == 0 ? 'required|agencia' : 'agencia'">

          <p class="text-danger" v-show="errors.has('agencia')">{{ errors.first('agencia') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('conta')}">
          <label class="control-label" for="conta">Número da conta</label>

          <input
              type="text"
              class="form-control"
              id="conta"
              maxlength="20"
              v-model="solicitacao.contaCorrente"
              data-vv-name="conta"
              data-vv-as="número da conta"
              v-validate="solicitacao.formaPagamento == 0 ? 'required|conta' : ''">

          <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('tipoConta')}">
          <label class="control-label" for="tipo-conta">Tipo de conta</label>

          <select
              class="form-control"
              id="tipo-conta"
              v-model="solicitacao.tipoConta"
              data-vv-name="tipoConta"
              data-vv-as="tipo de conta"
              v-validate="solicitacao.formaPagamento == 0 ? 'required' : ''">
            <option value="">Selecione...</option>
            <option :value="tipoConta.id" v-for="tipoConta in tiposConta">{{ tipoConta.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoConta')">{{ errors.first('tipoConta') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento-rateio/juridica/componentes/compartilhado/FormDadosBancarios.vue